export const SHOP_IMPORTED = 'shop_imported';
export const SHOP_CREATED = 'shop_created';
export const APEX_AUTO_APP = 'apex_auto_app';
export const WALK_IN = 'walk_in';

export const USER_TYPES = {
    SHOP_IMPORTED: 'shop_imported',
    SHOP_CREATED: 'shop_created',
    APEX_AUTO_APP: 'apex_auto_app',
    WALK_IN: 'walk_in',
};

/** Appointment status keys (used in API and kanban columns) */
export const APPOINTMENT_STATUS = {
    WAITING_FOR_DROP_OFF: 'waiting_for_drop_off',
    VEHICLE_DROPPED_OFF: 'vehicle_dropped_off',
    IN_PROGRESS: 'in_progress',
    READY_FOR_PICK_UP: 'ready_for_pick_up',
    CUSTOMER_PAID: 'customer_paid',
    MARK_AS_NO_SHOW: 'mark_as_no_show',
};

/** Map appointment status key -> display label (matches TodayAppointment column/menu labels) */
export const APPOINTMENT_STATUS_LABEL = {
    [APPOINTMENT_STATUS.WAITING_FOR_DROP_OFF]: 'Waiting for Drop Off',
    [APPOINTMENT_STATUS.VEHICLE_DROPPED_OFF]: 'Vehicle Dropped Off',
    [APPOINTMENT_STATUS.IN_PROGRESS]: 'In Progress',
    [APPOINTMENT_STATUS.READY_FOR_PICK_UP]: 'Ready for Pick Up',
    [APPOINTMENT_STATUS.CUSTOMER_PAID]: 'Customer Paid',
    [APPOINTMENT_STATUS.MARK_AS_NO_SHOW]: 'Mark as No Show',
};
